export default __webpack_public_path__ + "static/media/Mothercow.aa886f62.png";